import * as React from 'react';
import { cn } from '@/lib/utils';

const Input = React.forwardRef(({ className, type, error, ...props }, ref) => (
  <input
    type={type}
    className={cn(
      'block min-h-12 h-12 w-full rounded-md border border-input bg-card px-3 py-2 text-sm shadow-xs transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
      error && 'border-error focus-visible:ring-error',
      className
    )}
    ref={ref}
    {...props}
  />
));
Input.displayName = 'Input';

const InputWrapper = React.forwardRef(({ className, label, error, hint, id, children, ...props }, _ref) => {
  const inputId = id || props.name;
  return (
    <div className={cn('space-y-2', className)}>
      {label && (
        <label htmlFor={inputId} className="text-sm font-medium text-foreground">
          {label}
        </label>
      )}
      {children}
      {error && <p className="text-sm text-error">{error}</p>}
      {hint && !error && <p className="text-sm text-muted-foreground">{hint}</p>}
    </div>
  );
});
InputWrapper.displayName = 'InputWrapper';

export { Input, InputWrapper };
